// @flow

import React from 'react';
import Channel from '@sendbird/uikit-react/Channel';
import { Flex, Text } from '@locus-taxy/neo-ui';
import { useTranslation } from 'react-i18next';
import ChatHeader from 'common/modules/chat/components/ChatWindow/Header';
import Footer from 'common/modules/chat/components/ChatWindow/Footer';
import useChatGlobalState from 'common/modules/chat/hooks/useChatGlobalState';
import UserProfileImage from '../UserProfileImage';

type Props = {
    selectedProfile: string,
    closeMessageWindow: () => void,
    lastUnsentMessage: string,
    setLastUnsentMessage: (m: string) => void
};

const EmptyChannel = () => {
    const { userProfile: user } = useChatGlobalState();
    const { t } = useTranslation('liveView');

    return (
        <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            flex="1"
            minHeight="0"
        >
            <UserProfileImage url={user?.photoUrl} />
            <Text color="grey.600" fontSize={1}>
                {t('riderManagerChat.newConversation')}
            </Text>
            <Text color="grey.600" fontWeight={600} fontSize={3}>
                {user?.name}
            </Text>
        </Flex>
    );
};

const ChatWindow = ({
    selectedProfile,
    closeMessageWindow,
    lastUnsentMessage,
    setLastUnsentMessage
}: Props): React$Element<any> => {
    const ChatHeaderComponent = () => (
        <ChatHeader closeMessageWindow={closeMessageWindow} />
    );
    const FooterWithProps = () => (
        <Footer
            lastUnsentMessage={lastUnsentMessage}
            setLastUnsentMessage={setLastUnsentMessage}
        />
    );

    return (
        <Channel
            channelUrl={selectedProfile}
            renderChannelHeader={ChatHeaderComponent}
            renderPlaceholderEmpty={() => <EmptyChannel />}
            renderMessageInput={FooterWithProps}
            isReactionEnabled
            disableUserProfile
            replyType="QUOTE_REPLY" // for showing quoted replies
        />
    );
};

export default ChatWindow;
